/**
 * Contains options for Role Autocomplete Controller
 */
export class RoleAutocompleteControllerOptions {
    /**
     * Optional array of role IDs to filter by.
     * When provided, only these specific roles will be fetched via multiGet.
     * When not provided, all roles will be fetched via getAll.
     */
    ids?: Array<string>;
}
